import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthentication } from "../wrappers/UseAuthentication";

const RequireAuth = () => {
  const { isAuthenticated } = useAuthentication();
  const location = useLocation();

  if (!isAuthenticated) {
    const target = location.pathname.replace(/^\//, "");
    const search = target ? `?redirect=${encodeURIComponent(target)}` : "";
    return <Navigate to={`/signin${search}`} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
